import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { reactive, onMounted } from 'vue';
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'SwanPayContainer',
  props: {
  session: Object,
},
  emits: ['payment:success', 'payment:error'],
  setup(__props, { emit: __emit }) {

const emits = __emit
const props = __props;

const state = reactive({
    configuration: {
        environment: process.env.VUE_APP_ADYEN_ENVIRONMENT,
        clientKey: process.env.VUE_APP_ADYEN_CLIENT_KEY,
        analytics: {
            enabled: false // Set to false to not send analytics data to Adyen.
        },
        session: props.session,
        onPaymentCompleted: (result: any, component: any) => {
            emits('payment:success', result);
        },
        onError: (error: any, component: any) => {
            emits('payment:error', error);
        },
        paymentMethodsConfiguration: {
            card: {
                hasHolderName: true,
                holderNameRequired: true,
                billingAddressRequired: false,

                // styles: {
                //     base: {
                //         color: "#ffffff"
                //     },
                //     error: {},
                //     placeholder: {},
                //     validated: {}
                // }
            }
        }
    }
});

const initialiseAdyen = async() => {
    const checkout = await AdyenCheckout(state.configuration);
    const dropinComponent = checkout.create('dropin').mount('#dropin-container');
};

onMounted(() => {
    initialiseAdyen();
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { class: "w-50" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("div", { id: "dropin-container" }, null, -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})